import axios from "axios";

const setApiUrl = document.getElementById('app').getAttribute('data-ip');
const instance = axios.create({
    baseURL: setApiUrl + '/api/subscriber',
});


instance.interceptors.request.use((config) => {
    let user = JSON.parse(localStorage.getItem('user'));
    const token = user.token;
    config.headers.Authorization = token ? 'Bearer ' + token : null;


    return config;
})

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return error.response;
    }
)

export default instance